/* eslint-disable */
// import libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Space } from 'antd';
import Link from '@material-ui/core/Link';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

// import custom components
import EcgLoader from 'legacy/containers/EcgLoader';
import { DatePopover, SearchPopover } from 'legacy/containers/Popovers';
import { DATASOURCES, getDataSource } from 'state/services/utils';
import CustomTableComponent from '../../components/Common/Table/CustomTableComponent';
import TableHeader from '../../components/Common/Table/TableHeader';
import FormattedDate from '../../components/Common/FormattedDate';

// filter components

// constants
import { CONDITION_COMPARE_TYPE } from '../../components/Common/Table/Constants/Constants';
import {
  AlertBoldTextCell,
  AlertHighlightCell,
} from '../../components/Common/Table/Utilities/CellStyle';
// constants
import { ACUITY_MAP } from '../../components/Common/Table/Constants/Constants';

// import actions
import {
  setInitialKardiaRxEcgTableData,
  getKardiaRxEcgTableData,
  routeChangeAction,
  updatedSelectedRxRecording,
  getKardiaRxEcgTableDownloadReport,
} from '../../state/kardiaRxIdtf/KardiaRxIDTFEcgTableActions';

import { printTechIntrString } from '../../pages/Annotation/utils/TechIntrParser';

import FullWidthECGPreview from '../../pages/Annotation/components/FullECGPreview';

// import css
import styles from './KardiaRxEcgTable.css';

const FILTER_TYPES = {
  ACUITY: 'acuity',
  DATE: 'date',
  ANALYSIS: 'analysis',
  SYMPTOMS: 'symptoms',
  ACTIVITY: 'activity',
};

const serviceType = {
  MCT : 'mct'
}


// Tooltip Style
const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    border: '1px solid black'
  },
}))(Tooltip);

class KardiaRxEcgTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredData: [],
      filterApplied: false,
      startDate: new Date(),
      endDate: new Date(),
      filters: {
        showAcuityFilter: false,
        showDateFilter: false,
        showAnalysisFilter: false,
        showSymptomsFilter: false,
        showActivityFilter: false,
      },
    };
  }

  UNSAFE_componentWillMount() {
    const { match, location } = this.props;
    this.props.setInitialState(match, location);
    this.props.getKardiaRxEcgTableData();
  }

  componentDidMount = () => {
    // this.removeDefaultSortClass();
  };

  componentWillReceiveProps = () => {
    // this.removeDefaultSortClass();
  };

  // remove default sort Icon class to fit custom icon
  removeDefaultSortClass = () => {
    if (document.querySelectorAll('.ant-table-column-sorter-full').length) {
      document
        .querySelectorAll('.ant-table-column-sorter-full')
        .forEach(e => e.remove());
    }
  };


  getTableColumns = () => {
    const { me } = this.props;
     return [
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="ACUITY"
              keyMap="acuity"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.ACUITY)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.ACUITY)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Acuity..."
                  />
                </Space>
              }
              showFilter={this.state.filters.showAcuityFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'acuity',
        key: 'acuity',
        width: 100,
        sorter: (a, b) => a.acuity && a.acuity.localeCompare(b.acuity),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          let rowStyle = {};
          if (record.acuity === 'stable') {
            rowStyle = { borderLeft: '4px solid #9DD3DE' };
          } else if (record.acuity === 'mdn') {
            rowStyle = { borderLeft: '4px solid #CC3D3F' };
          }
          return {
            style: { ...rowStyle, ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          const data = record.acuity && `${record.acuity}`;
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              {ACUITY_MAP[data]}
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="DATE"
              keyMap="date"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.DATE)
              }
              filterPopOverComponent={
                <Space style={{ height: '200px' }} direction="vertical">
                  <DatePopover
                    handleOnChange={e => this.handleDateFilterChange(e)}
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                  />
                </Space>
              }
              showFilter={this.state.filters.showDateFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'date',
        key: 'date',
        width: 100,
        sorter: (a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateA - dateB;
        },
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              <FormattedDate date={text} />
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="ANALYSIS"
              keyMap="analysis"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.ANALYSIS)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.ANALYSIS)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Analysis..."
                  />
                </Space>
              }
              showFilter={this.state.filters.showAnalysisFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'analysis',
        key: 'analysis',
        width: 220,
        sorter: (a, b) =>
          a.analysis && a.analysis.localeCompare(b.analysis),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          let data = '';
          if (record.analysis && record.analysis.length) {
            data = printTechIntrString(record.analysis);
            const analysisData = JSON.parse(record.analysis);
          }
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              <u>
                {data && data.length >= 50
                  ? data.substring(0, 49) + '...'
                  : data}
              </u>
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="PREVIEW"
              keyMap="preview"
              enableFilterRow={true}
              enableFilter={false}
              filterFunction={() => this.filterChange()}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'preview',
        key: 'preview',
        width: 360,
        onCell: () => {
          return {
            style: {    
              position: 'relative',
              padding: 0,
              overflow:'hidden',
              width: "360px",
              height: "77px",
              borderBottom: "0.1px solid #1F356866"
            },
          }
        },
        render: (text, record, index) => {
          if(record.highlightPreview || record.previewData){
            return (
              <React.Fragment> 
                {record.highlightPreview ? (
                  <FullWidthECGPreview 
                  classApplied
                  sample = {JSON.parse(record.highlightPreview).intervals[0].samples}
                  ecgTitle = {JSON.parse(record.highlightPreview).intervals[0].lead}
                  // beats = {JSON.parse(record.highlightPreview).beats}
                  height = {150}
                  />
                ) :(
                  <FullWidthECGPreview
                    classApplied
                    sample = {record.previewData.samples.leadI}
                    height = {150}
                  />
                )}
              </React.Fragment>
            )
          } else {
            return (
              <p style={{textAlign: 'center'}}>Preview Unavailable</p>
            )
          }
        }
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="SYMPTOMS"
              keyMap="symptoms"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.SYMPTOMS)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.SYMPTOMS)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Symptoms..."
                  />
                </Space>
              }
              showFilter={this.state.filters.showSymptomsFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'symptoms',
        key: 'symptoms',
        width: 180,
        sorter: (a, b) =>
        a.symptoms && `${a.symptoms}`.localeCompare(`${b.symptoms}`),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          const data = record.symptoms && `${record.symptoms}`;
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              {data && data.length >= 50 ? (
                <u>{data.substring(0, 49) + '...'}</u>
              ) : (
                <u>{data}</u>
              )}
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="ACTIVITY"
              keyMap="activities"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.ACTIVITY)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.ACTIVITY)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Activity..."
                  />
                </Space>
              }
              showFilter={this.state.filters.showActivityFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'activities',
        key: 'activities',
        width: 150,
        sorter: (a, b) =>
          a.activities && `${a.activities}`.localeCompare(`${b.activities}`),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          const data = record.activities && `${record.activities}`;
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              {data}
            </p>
          );
        },
      },
    ]
  }




  getTableMctColumns = () => {
    const { me } = this.props;
     return [
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="ACUITY"
              keyMap="acuity"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.ACUITY)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.ACUITY)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Acuity..."
                  />
                </Space>
              }
              showFilter={this.state.filters.showAcuityFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'acuity',
        key: 'acuity',
        width: 80,
        sorter: (a, b) => a.acuity && a.acuity.localeCompare(b.acuity),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          let rowStyle = {};
          if (record.acuity === 'stable') {
            rowStyle = { borderLeft: '4px solid #9DD3DE' };
          } else if (record.acuity === 'mdn') {
            rowStyle = { borderLeft: '4px solid #CC3D3F' };
          }
          return {
            style: { ...rowStyle, ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          const data = record.acuity && `${record.acuity}`;
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              {ACUITY_MAP[data]}
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="DATE"
              keyMap="date"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.DATE)
              }
              filterPopOverComponent={
                <Space style={{ height: '200px' }} direction="vertical">
                  <DatePopover
                    handleOnChange={e => this.handleDateFilterChange(e)}
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                  />
                </Space>
              }
              showFilter={this.state.filters.showDateFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'date',
        key: 'date',
        width: 80,
        sorter: (a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return dateA - dateB;
        },
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              <FormattedDate date={text} />
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="ANALYSIS"
              keyMap="analysis"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.ANALYSIS)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.ANALYSIS)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Analysis..."
                  />
                </Space>
              }
              showFilter={this.state.filters.showAnalysisFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'analysis',
        key: 'analysis',
        width: 120,
        sorter: (a, b) =>
          a.analysis && a.analysis.localeCompare(b.analysis),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          let data = '';
          if (record.analysis && record.analysis.length) {
            data = printTechIntrString(record.analysis);
            const analysisData = JSON.parse(record.analysis);
          }
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              <u>
                {data && data.length >= 50
                  ? data.substring(0, 49) + '...'
                  : data}
              </u>
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="SYMPTOMS"
              keyMap="symptoms"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.SYMPTOMS)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.SYMPTOMS)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Symptoms..."
                  />
                </Space>
              }
              showFilter={this.state.filters.showSymptomsFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'symptoms',
        key: 'symptoms',
        width: 200,
        sorter: (a, b) =>
          a.symptoms && `${a.symptoms}`.localeCompare(`${b.symptoms}`),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          const data = record.symptoms && `${record.symptoms}`;
          return (
            <div>
            {
              data && data.length >= 130 ? 
              <LightTooltip title={data}>
              <p
                style={{
                  fontWeight: boldText === true ? 'bold' : 'normal',
                }}
              >
                  {data && data.length >= 130
                    ? data.substring(0, 129) + '...'
                    : data}
              </p>
             </LightTooltip> :  <p
                style={{
                  fontWeight: boldText === true ? 'bold' : 'normal',
                }}
              >
                  {data && data.length >= 130
                    ? data.substring(0, 129) + '...'
                    : data}
              </p>
            }
          </div>
            // <p
            //   style={{
            //     fontWeight: boldText === true ? 'bold' : 'normal',
            //   }}
            // >
            //   {data && data.length >= 130 ? (
            //     <u>{data.substring(0, 129) + '...'}</u>
            //   ) : (
            //     <u>{'data'}</u>
            //   )}
            // </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="ACTIVITY"
              keyMap="activities"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.ACTIVITY)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.ACTIVITY)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Activity..."
                  />
                </Space>
              }
              showFilter={this.state.filters.showActivityFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'activities',
        key: 'activities',
        width: 180,
        sorter: (a, b) =>
        a.activities && `${a.activities}`.localeCompare(`${b.activities}`),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          const data = record.activities && `${record.activities}`;
          return (

            <div>
              {
                data && data.length >= 80 ? 
                <LightTooltip title={data}>
                <p
                  style={{
                    fontWeight: boldText === true ? 'bold' : 'normal',
                  }}
                >
                    {data && data.length >= 80
                      ? data.substring(0, 79) + '...'
                      : data}
                </p>
               </LightTooltip> :  <p
                  style={{
                    fontWeight: boldText === true ? 'bold' : 'normal',
                  }}
                >
                    {data && data.length >= 80
                      ? data.substring(0, 79) + '...'
                      : data}
                </p>
              }
            </div>
            // <p
            //   style={{
            //     fontWeight: boldText === true ? 'bold' : 'normal',
            //   }}
            // >
            //    {data && data.length >= 80 ? (
            //     <u>{data.substring(0, 79) + '...'}</u>
            //   ) : (
            //     <u>{'data'}</u>
            //   )}
            // </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="DOWNLOAD REPORT"
              keyMap="downloadReport"
              enableFilterRow={true}
              enableFilter={false}
            />
          );
        },
        dataIndex: 'downloadReport',
        key: 'downloadReport',
        width: 100,
        // sorter: (a, b) =>
        //   a.activities && a.activities.localeCompare(b.activities),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.acuity,
            CONDITION_COMPARE_TYPE.EQUAL,
            'mdn',
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isConfirmed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              <Link
                underline ='always'
                component="button"
                variant="body2"
                //styles.boldCSS : styles.skinyCSS
                className = {  boldText === true  ? styles.boldCSS : styles.skinyCSS }
                onClick={(event) => {
                  // this.props.getKardiaRxEcgTableDownloadReport(record.recordingId);
                  // event.stopPropagation();
                }}
              >
                DOWNLOAD REPORT
              </Link>           
            </p>
          );
        },
      },
    ]
  }



  getTableData = () => {
    if (this.state.filterApplied && this.state.filteredData.length>0) {
      return this.state.filteredData;
    } else {
    const { KARDIA_RX_ECGS } = this.props;
    const recordings = KARDIA_RX_ECGS.recordings.data[0];
    return recordings;
    }
  };

  // Row clicked
  clickedRow = rowData => {
    const { updateRecordingState, pateintEnrollOverview } = this.props;
    if(pateintEnrollOverview && pateintEnrollOverview.data && pateintEnrollOverview.data['latest_enrollment'] && pateintEnrollOverview.data['latest_enrollment'].service_type && pateintEnrollOverview.data['latest_enrollment'].service_type.toLowerCase() == serviceType.MCT ){
      this.props.getKardiaRxEcgTableDownloadReport(rowData.recordingId);
    } else {
      this.props.routeChangeAction(rowData.recordingId);
      this.props.updateRecordingState(rowData);
    }
  };

  handleOnOutsidePopoverClick = () => {
    this.setState({
      ...this.state,
      filters: {
        ...this.state.filters,
        showAcuityFilter: false,
        showDateFilter: false,
        showAnalysisFilter: false,
        showSymptomsFilter: false,
        showActivityFilter: false,
      },
    });
  };

  filterChange = filterType => {
    let filterValue = this.state.filters;
    switch (filterType) {
      case FILTER_TYPES.ACUITY:
        filterValue.showAcuityFilter = true;
        break;
      case FILTER_TYPES.DATE:
        filterValue.showDateFilter = true;
        break;
      case FILTER_TYPES.ANALYSIS:
        filterValue.showAnalysisFilter = true;
        break;
      case FILTER_TYPES.SYMPTOMS:
        filterValue.showSymptomsFilter = true;
        break;
      case FILTER_TYPES.ACTIVITY:
        filterValue.showActivityFilter = true;
        break;
      default:
        break;
    }
    this.setState({
      ...this.state,
      filters: {
        ...filterValue,
      },
    });
  };

  handleDateFilterChange = e => {
    let filteredEvents = [];
    this.setState({
      startDate: e.startDate,
      endDate: e.endDate,
    });
    filteredEvents = this.getTableData().filter(item => {
      return (
        new Date(item.date) >= e.startDate && new Date(item.date) <= e.endDate
      );
    });
    this.setState({filterApplied: true, filteredData: filteredEvents });
  };

  handleOnChange = (e, filterType) => {
    let filteredEvents = [];
    const searchText = e.toLowerCase();
    if (searchText == '') {
      this.setState({ ...this.state, filterApplied: false });
    } else {
    switch (filterType) {
      case FILTER_TYPES.ACUITY:
        filteredEvents = this.getTableData().filter(item => {
          item.acuity =item.acuity && item.acuity.toLowerCase();
          return item.acuity && item.acuity.includes(searchText);
        });
        break;
      case FILTER_TYPES.ANALYSIS:
        filteredEvents = this.getTableData().filter(item => {
          return item.analysis && printTechIntrString(item.analysis).toLowerCase().includes(searchText);
        });
        break;
      case FILTER_TYPES.SYMPTOMS:
        filteredEvents = this.getTableData().filter(item => {
          return item.symptoms && `${item.symptoms}`.toLowerCase().includes(searchText)
        });
        break;
      case FILTER_TYPES.ACTIVITY:
        filteredEvents = this.getTableData().filter(item => {
          return item.activities && `${item.activities}`.toLowerCase().includes(searchText)
        });
        break;
      default:
        break;
    }
    this.setState({...this.state, filterApplied: true, filteredData: filteredEvents });
  }};

  render() {
    const { KARDIA_RX_ECGS, pateintEnrollOverview, isIdtfEnabled } = this.props;
    return (
      <React.Fragment>
        {
          isIdtfEnabled ? 
           pateintEnrollOverview.isFetching ? (
            <EcgLoader />
          ) : (
            <CustomTableComponent
              columns={ pateintEnrollOverview && pateintEnrollOverview.data && pateintEnrollOverview.data['latest_enrollment'] && pateintEnrollOverview.data['latest_enrollment'].service_type && pateintEnrollOverview.data['latest_enrollment'].service_type.toLowerCase() == serviceType.MCT ?  this.getTableMctColumns() : this.getTableColumns()}
              data={
                this.state.filterApplied && this.state.filteredData
                  ? this.state.filteredData
                  : KARDIA_RX_ECGS.recordings.data[0]
              }
              clickedRow={this.clickedRow}
              scrollHeight={{ y: 'calc(100vh - 45em)' }}
            />
          )
          :
          KARDIA_RX_ECGS.recordings.isFetching ? (
            <EcgLoader />
          ) : (
            <CustomTableComponent
              columns={this.getTableColumns()}
              data={
                this.state.filterApplied && this.state.filteredData
                  ? this.state.filteredData
                  : KARDIA_RX_ECGS.recordings.data[0]
              }
              clickedRow={this.clickedRow}
              scrollHeight={{ y: 'calc(100vh - 45em)' }}
            />
          )
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const me = getDataSource(state, DATASOURCES.ME);
  const KARDIA_RX_ECGS = state.kardiaRx.kardiaRxIDTFEcg;

  return {
    me,
    KARDIA_RX_ECGS,
  };
};

const mapActionCreators = {
  setInitialState: setInitialKardiaRxEcgTableData,
  getKardiaRxEcgTableData,
  routeChangeAction,
  updateRecordingState: updatedSelectedRxRecording,
  getKardiaRxEcgTableDownloadReport,
};

export default connect(
  mapStateToProps,
  mapActionCreators,
)(injectIntl(KardiaRxEcgTable));



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxEcgTable/KardiaRxEcgTable.jsx